import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'slNumber',
    standalone: false
})
export class NumberPipe implements PipeTransform {
    // the function doesn't round, only truncates decimal places spedified.
    // If more decimal places are specified than provided, it attaches 0 to have the required decimal places.
    // Example: 1.2 with decimalPlaces: 2, becomes 1.20
    transform(value: any, decimalPlaces?: number): string {
        // eslint-disable-next-line no-null/no-null
        if (value === undefined || value === null) {
            return '';
        }

        let sign = '';

        if (value < 0) {
            // work only with positive numbers and keep the sign to attach down bellow
            value = value * -1;
            sign = '-';
        }

        const groupingSep = ' '; // the character used as thousands separator

        const v = value.toString();
        const s = v.split('.');
        const l = [...s[0]];
        const d = s[1] ? [...s[1]] : [];

        decimalPlaces = decimalPlaces === undefined ? d.length : decimalPlaces; // default is no changes to decimal part

        const stack = [],
            grs = 3;
        let pos = 0;

        while (l.length > 0) {
            if (pos > 0 && pos % grs === 0) {
                stack.unshift(groupingSep);
            }

            stack.unshift(l.pop());
            pos++;
        }

        let dp = [];

        if (decimalPlaces > 0) {
            dp = d.slice(0, decimalPlaces);

            while (dp.length < decimalPlaces) {
                dp.push(0); // add trailing zeros
            }
        }

        const decimalSeparator = '.';
        let r = sign + stack.join('');

        if (dp.length > 0) {
            r = r + decimalSeparator + dp.join('');
        }

        return r;
    }
}
